import React from 'react';

interface HeartCogIconProps {
  className?: string;
}

function HeartCogIcon({ className }: HeartCogIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
      className={className}
    >
      <g id="settings_heart">
        <mask
          id="mask0_13282_37018"
          width="25"
          height="25"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
        >
          <path id="Bounding box" fill="#D9D9D9" d="M.066.35h24v24h-24z"></path>
        </mask>
        <g mask="url(#mask0_13282_37018)">
          <path
            id="settings_heart_2"
            fill="currentColor"
            d="M12.117 15.925q.2 0 .375-.063a.9.9 0 0 0 .325-.212l2.8-2.8q.424-.426.55-1.038a1.94 1.94 0 0 0-.125-1.187 2.15 2.15 0 0 0-.75-.925 1.9 1.9 0 0 0-1.125-.35q-.625 0-1.125.387-.5.388-.925.813-.45-.426-.938-.813a1.74 1.74 0 0 0-1.112-.387q-.625 0-1.138.337-.511.338-.762.913-.25.575-.113 1.187.138.612.563 1.063l2.775 2.8q.15.15.337.212.188.063.388.063m-1.225 6.425q-.675 0-1.163-.45-.487-.45-.587-1.1l-.225-1.65a4 4 0 0 1-.613-.3 8 8 0 0 1-.562-.375l-1.55.65q-.625.275-1.25.05a1.84 1.84 0 0 1-.975-.8l-1.175-2.05a1.59 1.59 0 0 1-.2-1.225q.15-.65.675-1.075l1.325-1a2.4 2.4 0 0 1-.025-.338v-.675q0-.162.025-.337l-1.325-1A1.9 1.9 0 0 1 2.592 9.6q-.15-.65.2-1.225l1.175-2.05q.35-.576.975-.8.625-.226 1.25.05l1.55.65q.275-.201.575-.375.3-.175.6-.3l.225-1.65q.1-.65.587-1.1.488-.45 1.163-.45h2.35q.675 0 1.162.45t.588 1.1l.225 1.65q.324.125.612.3.288.174.563.375l1.55-.65q.624-.276 1.25-.05.624.225.975.8l1.175 2.05q.35.574.2 1.225-.15.65-.675 1.075l-1.325 1q.024.175.025.337v.675q0 .162-.05.338l1.325 1q.525.424.675 1.075.15.65-.2 1.225l-1.2 2.05q-.35.575-.975.8-.626.225-1.25-.05l-1.5-.65a7 7 0 0 1-.575.375q-.3.174-.6.3l-.225 1.65q-.1.65-.588 1.1-.487.45-1.162.45zm.175-2h1.975l.35-2.65q.775-.201 1.437-.588.663-.387 1.213-.937l2.475 1.025.975-1.7-2.15-1.625q.125-.351.175-.738a6.2 6.2 0 0 0 0-1.575 3.5 3.5 0 0 0-.175-.737l2.15-1.625-.975-1.7-2.475 1.05a5.6 5.6 0 0 0-1.213-.963A5.6 5.6 0 0 0 13.392 7l-.325-2.65h-1.975L10.742 7q-.775.2-1.438.587t-1.212.938L5.617 7.5l-.975 1.7 2.15 1.6q-.125.375-.175.75a6 6 0 0 0-.05.8q0 .4.05.775t.175.75L4.642 15.5l.975 1.7 2.475-1.05q.55.575 1.212.962.663.387 1.438.588z"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default HeartCogIcon;
